// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1qZqd","addWidgetButton":"Header_addWidgetButton__2HiDv","dashboardTabs":"Header_dashboardTabs__2g8p-","active":"Header_active__R4Lll"};